<template>
  <div class="flex-row align-items-center sfondo">
    <CContainer class="pt-5" style="height: 100vh;">
      <CRow class="justify-content-center">
        <CCol md="4" sm="1"></CCol>
        <CCol md="4" sm="10">
          <CRow class="pt-3 pb-3 text-center m-0" align-horizontal="center">
            <img src="img/logo_wapiti.png" style="max-width: 300px;" />
          </CRow>
          <CRow align-horizontal="center" class="m-0">
            <div>
              <CRow align-horizontal="center" class="pt-2 text-center m-0">
                <span class="h1 login-txt"><strong>Accesso al CRM</strong></span>
              </CRow>

              <!-- IMPORTANTE: niente action, gestiamo in JS -->
              <CRow align-horizontal="center" class="m-0">
                <form id="formLogin" @submit.prevent="doLogin">
                  <CRow align-horizontal="center" class="m-0 pt-3 pb-3 text-center">
                    <CInput id="user" v-model.trim="user" class="col-sm-10 pl-0 pr-0 mb-0" placeholder="Username" name="user" size="lg">
                      <template #prepend-content>
                        <i class="fas fa-user"></i>
                      </template>
                    </CInput>

                    <CInput id="password" v-model="password" class="col-sm-10 pl-0 pr-0 mb-0" placeholder="Password"
                      type="password" autocomplete="current-password" name="password" size="lg">
                      <template #prepend-content>
                        <i class="fas fa-unlock-alt"></i>
                      </template>
                    </CInput>

                    <div v-if="messaggio_errore" style="color: darkred; font-weight: bold" class="col-sm-10 pl-0 pr-0">
                      <CAlert color="danger" closeButton>Credenziali errate</CAlert>
                    </div>

                    <CInput id="accedi_btn" type="submit" color="primary" class="col-sm-10 mt-0 mb-0 px-0"
                      :value="loading ? 'Accesso...' : 'Accedi'" :disabled="loading" />
                  </CRow>
                </form>
              </CRow>
            </div>
          </CRow>
        </CCol>
        <CCol md="4" sm="1" style="text-align: right"></CCol>
      </CRow>
    </CContainer>
  </div>
</template>

<script>
import store from "../../store";
import axios from "axios";

export default {
  name: "Login",
  data() {
    return {
      data_login: "",
      messaggio_errore: false,
      user: "",
      password: "",
      loading: false,
    };
  },
  created() {
    // Al caricamento della login controllo: se arrivo con un errore di autenticazione lo mostro altrimenti svuoto il local storage chiamando la funzione "user_logout"
    if (this.$route.query.errore) {
      this.messaggio_errore = true;
      this.$router.replace({ name: "Login" });
    }

    store.commit("user_logout");
    localStorage.removeItem("utente");
    localStorage.removeItem("userID");
    localStorage.removeItem("chisono_data");
    sessionStorage.clear();
  },

  methods: {
    async doLogin() {
      this.messaggio_errore = false;
      this.loading = true;
      try {
        const payload = { user: this.user, password: this.password };
        const res = await axios.post("https://crm.wapiti.it/API/CRM/accessoCRM", payload);

        // supponiamo risposta OK con { ok: true, userID, chisono_data }
        const data = res.data;

        if (data && data.ok) {
          // salva ciò che ti serve
          localStorage.setItem("utente", "ok");
          await this.$store.dispatch('acl/fetchACL');
          // this.$router.replace({ name: 'Dashboard' }); // o dove vuoi atterrare
          localStorage.setItem("userID", data.userID);
          localStorage.setItem("chisono_data", JSON.stringify(data.chisono_data || {}));
          localStorage.setItem("userCRMInfo", JSON.stringify(data.userCRMInfo || {}));
          localStorage.setItem("lastLogin", new Date().toISOString());

          
          sessionStorage.setItem("tokenElearning", "SLKJDO20300SLXPA...A38902");
          this.loading = false;
          console.log("Login effettuato con successo");
          // vai alla home CRM
          this.$router.push({ name: "Crm" });
        } else {
          this.messaggio_errore = true;
        }
      } catch (e) {
        console.error("Errore login:", e);
        this.messaggio_errore = true;
      } finally {
        this.loading = false;
      }
    },
    printDate: function () {
      return new Date();
    },
    getUserValue(submitEvent) {
      this.data_login = this.printDate();
      localStorage.setItem("user", submitEvent.target.elements.user.value);
      localStorage.setItem("pwd", submitEvent.target.elements.password.value);
      localStorage.setItem("lastLogin", this.data_login);
      return true;
    },
  },
};
</script>
<style scoped>
/* @import url("https://fonts.googleapis.com/css2?family=Indie+Flower&display=swap"); */
@font-face {
  font-family: Shadows;
  src: url("/img/fonts/Shadows.ttf");
}

.sfondo {
  /* background: url("/img/slide_1_bg.jpg") bottom right,
    linear-gradient(to right bottom, #1cc7d0, #013ca6, #013ca6, #1cc7d0) !important; */
  background-color: white;
  background-attachment: fixed;
  background-position: center;
  background-size: cover;
  font-family: "Montserrat", sans-serif;
  height: 100vh;
}

.login-img {
  /* position: absolute; */
  z-index: 10;

  padding-bottom: 2.5rem;
  /* margin: auto; */
}

.login-txt {
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}

.login_sx {
  position: absolute;
  bottom: 0;
  left: 0;
  max-height: 60%;
  z-index: 0;
}

.login_dx {
  position: absolute;
  top: 0;
  right: 0;
  max-height: 30%;
  z-index: 0;
}

.testo_login {
  color: #1f4b6b !important;
  font-size: 1rem;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  font-weight: 500;
  margin-bottom: 1rem;
  line-height: 1.7rem;
}

.payoff {
  color: #ef7918;
  font-family: "Shadows";
  font-size: 2rem;
  line-height: 3rem;
}

.entra_btn {
  border-radius: 3px;
  font-weight: 400;
  width: 30%;
  background: #1f4b6b;
  border: none;
  margin: 1.5em 0 1.5em;
  outline: none;
  letter-spacing: 1px;
  font-size: 1.25em;
  padding: 14px 0;
  color: #fff;
  transition: 0.5s ease-in;
  -webkit-transition: 0.5s ease-in;
  -moz-transition: 0.5s ease-in;
  -o-transition: 0.5s ease-in;
  -ms-transition: 0.5s ease-in;
  cursor: pointer;
}

.entra_btn:hover {
  background: #1255a6;
}

#formLogin {
  margin-top: 10px;
  border-radius: 5px;
  /* border: solid 1px #d8dbe07d; */
}
</style>
